import { gql } from 'graphql-tag'

export const fetchAdminCampaigns = gql`
  query AdminCampaignPage($date: String!, $stationId: ID, $includeChainCampaigns: Boolean) {
    campaigns(stationId: $stationId, includeChainCampaigns: $includeChainCampaigns, includeHidden: true) {
      id
      name
      description
      startTime
      endTime
      stationId
      isVisible
    }
    campaignsAfterDate(date: $date, stationId: $stationId, includeHidden: true) {
      id
      name
      description
      startTime
      endTime
      stationId
      isVisible
    }
  }
`

export const addNewCampaignMutation = gql`
  mutation AddNewCampaign($input: CampaignInput!) {
    addCampaign(input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`
export const updateCampaignMutation = gql`
  mutation UpdateCampaign($id: ID!, $input: CampaignInput!) {
    updateCampaign(id: $id, input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`

export const addNewStationCampaignMutation = gql`
  mutation AddNewStationCampaign($stationId: ID!, $input: CampaignInput!) {
    addStationCampaign(stationId: $stationId, input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`

export const updateStationCampaignMutation = gql`
  mutation UpdateStationCampaign($id: ID!, $stationId: ID!, $input: CampaignInput!) {
    updateStationCampaign(id: $id, stationId: $stationId, input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`

export const setCampaignVisibilityMutation = gql`
  mutation SetCampaignVisibility($campaignId: ID!, $stationId: ID!, $isVisible: Boolean!) {
    setCampaignVisibility(campaignId: $campaignId, stationId: $stationId, isVisible: $isVisible) {
      id
      isVisible
    }
  }
`
